import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 mb-4">
            视频精选
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            精彩视频
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            精选全网最热黑料视频，高清流畅在线观看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform backdrop-blur-sm">
                    <i className="ri-play-fill text-foreground-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-[10px] font-medium rounded bg-black/60 text-foreground-200 whitespace-nowrap backdrop-blur-sm">
                  {item.duration}
                </span>
                <span className="absolute top-2 left-2 px-2 py-0.5 text-[11px] font-medium rounded bg-accent-500/80 text-foreground-50 whitespace-nowrap backdrop-blur-sm">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次播放
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}